var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-table"},[_c('ag-grid-vue',{staticClass:"userTable wk-advanced-table wk-is-striped",attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"gridOptions":_vm.gridOptions,"enableColResize":true,"pagination":_vm.pagination,"paginationPageSize":this.paginationPageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }